export type genderIdentityOptions = 'MULHER' | 'HOMEM' | 'MULHER_TRANS' | 'HOMEM_TRANS' | 'NAO_BINARIO'

export const genderIdentityKeys = {
    MULHER: 'MULHER',
    HOMEM: 'HOMEM',
    MULHER_TRANS: 'MULHER_TRANS',
    HOMEM_TRANS: 'HOMEM_TRANS',
    NAO_BINARIO: 'NAO_BINARIO',
}

export const genderIdentity = {
    [genderIdentityKeys.MULHER]: {
        label: 'Mulher',
        value: genderIdentityKeys.MULHER,
    },
    [genderIdentityKeys.HOMEM]: {
        label: 'Homem',
        value: genderIdentityKeys.HOMEM,
    },
    [genderIdentityKeys.MULHER_TRANS]: {
        label: 'Mulher trans',
        value: genderIdentityKeys.MULHER_TRANS,
    },
    [genderIdentityKeys.HOMEM_TRANS]: {
        label: 'Homem trans',
        value: genderIdentityKeys.HOMEM_TRANS,
    },
    [genderIdentityKeys.NAO_BINARIO]: {
        label: 'Não binário',
        value: genderIdentityKeys.NAO_BINARIO,
    },
}

export const genderIdentityList = [
    genderIdentity.HOMEM,
    genderIdentity.MULHER,
    genderIdentity.HOMEM_TRANS,
    genderIdentity.MULHER_TRANS,
    genderIdentity.NAO_BINARIO,
]

export const biologicalSexKeys = {
    MASCULINO: 'MASCULINO',
    FEMININO: 'FEMININO',
}

export const biologicalSex = {
    FEMININO: { label: 'Feminino', value: biologicalSexKeys.FEMININO },
    MASCULINO: { label: 'Masculino', value: biologicalSexKeys.MASCULINO },
}

export const biologicalSexList = [biologicalSex.MASCULINO, biologicalSex.FEMININO]

export const genderListForSocialName = [
    genderIdentityKeys.HOMEM_TRANS,
    genderIdentityKeys.MULHER_TRANS,
    genderIdentityKeys.NAO_BINARIO,
]
